import Tasks from 'APP/Tasks';
import { HIGHLIGHTED_TEXT_ATTRIBUTE_NAME } from 'APP/constants/messages';
import { RouterState } from 'APP/router/constants';
import Entities from 'STORE';

import { focusMessage, IFocusMessageParams } from '../focusMessage/focusMessage';

interface IHighlightMessageTextParams extends IFocusMessageParams {
  text: string;
}

const HIGHLIGHT_TIMEOUT = 300;

let highlightTimer: ReturnType<typeof setTimeout> | null = null;

export async function highlightMessageText({
  groupId,
  messageId,
  isAnimated = true,
  text,
}: IHighlightMessageTextParams): Promise<void> {
  focusMessage({
    groupId,
    messageId,
    isAnimated,
    messageElementSelector: `[${HIGHLIGHTED_TEXT_ATTRIBUTE_NAME}="true"]`,
  });
  if (groupId !== Entities.GroupsStore.activeGroupId) {
    await Tasks.group.setActiveGroup({
      groupId,
      state: {
        [RouterState.hasGoBack]: true,
        [RouterState.groupId]: groupId,
        [RouterState.messageId]: messageId,
      },
    });
  }
  const group = Entities.GroupsStore.getGroupById(groupId);
  const messagesStore = group?.messagesStore;

  if (!messagesStore) {
    return;
  }
  if (highlightTimer) {
    clearTimeout(highlightTimer);
  }

  messagesStore?.setHighlightedMessageText(text, messageId);

  highlightTimer = setTimeout(() => {
    messagesStore?.unsetHighlightedMessageText();
  }, HIGHLIGHT_TIMEOUT);
}
